/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Gym_Access_TermsInputs */

const en_service_type_gym_access_terms = /** @type {(inputs: Service_Type_Gym_Access_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`gym, membership, day pass, fitness club, drop in`)
};

const pl_service_type_gym_access_terms = /** @type {(inputs: Service_Type_Gym_Access_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`siłownia, karnet, wejście jednorazowe, klub fitness, fitness klub, open`)
};

/**
* | output |
* | --- |
* | "gym, membership, day pass, fitness club, drop in" |
*
* @param {Service_Type_Gym_Access_TermsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_gym_access_terms = /** @type {((inputs?: Service_Type_Gym_Access_TermsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Gym_Access_TermsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_gym_access_terms(inputs)
	return en_service_type_gym_access_terms(inputs)
});